<div [matTooltip]="getTooltip()" [matTooltipDisabled]="!getTooltip()">
  <app-form-label [requiredField]="requiredField" [popoverHelpText]="popoverHelpText" *ngIf="!hideLabel">{{ this.label }}</app-form-label>

  <div data-visual-control>
  <div *ngIf="type !== 'text-area'" class="input-container" [ngClass]="{ hasPrefix: prefix }">
    <span #prefixSpan *ngIf="prefix" class="prefix">{{ prefix }}</span>
    <input
      matInput
      tabindex="0"
      [type]="type"
      [placeholder]="placeholder"
      [formControl]="formControl"
      [title]="label"
      [required]="requiredField"
      [readonly]="readonly"
      [email]="emailField"
      [step]="step"
      (blur)="onBlur()"
      [style]="inputStyle()"
      [ngClass]="{
        'size-small': this.size === 'small'
      }"
      [maxlength]="maxLength"
      [minlength]="minLength"
    />
  </div>

  <textarea
    *ngIf="type === 'text-area'"
    matInput
    tabindex="0"
    [type]="type"
    [placeholder]="placeholder"
    [formControl]="formControl"
    [title]="label"
    [required]="requiredField"
    [readonly]="readonly"
    [rows]="rows"
    [maxlength]="maxLength"
    [minlength]="minLength"
  ></textarea>

  <div
    *ngIf="type === 'text-area' && ((showCount && maxLength) || (formControl.hasError('required') && (formControl.dirty || touched())))"
    class="character-count-wrapper"
  >
    @if (formControl.dirty || touched()) {
      <mat-error *ngIf="formControl.hasError('required')">Required</mat-error>
    }
    <div *ngIf="showCount && maxLength" class="character-count">
      {{ characterCount }} / {{ maxLength }}
    </div>
  </div>

  <mat-hint *ngIf="hint && hint.length">{{ hint }}</mat-hint>

  @if (formControl.dirty || touched()) {
    <mat-error *ngIf="type !== 'text-area' && formControl.hasError('required')">Required</mat-error>
  }
  @if (touched()) {
    <mat-error *ngIf="formControl.hasError('email')">Not a valid email address</mat-error>
    <mat-error *ngIf="formControl.hasError('pattern')">{{ invalidRegexMessage }}</mat-error>
    <mat-error *ngIf="formControl.hasError('minlength')">
      Minimum {{ minLength }} {{ type === 'number' ? 'digits' : 'characters' }}
    </mat-error>
    <mat-error *ngIf="formControl.hasError('maxlength')">
      Maximum {{ maxLength }} {{ type === 'number' ? 'digits' : 'characters' }}
    </mat-error>
    <mat-error *ngIf="formControl.hasError('min')">Minimum value {{ formatNumberForDisplay(minNumericalValue, decimalPlaces) }}</mat-error>
    <mat-error *ngIf="formControl.hasError('max')">Maximum value {{ formatNumberForDisplay(maxNumericalValue, decimalPlaces) }}</mat-error>
    <mat-error *ngIf="formControl.hasError('decimalPlaces')"
      >Maximum {{ decimalPlaces }} decimal places</mat-error
    >
  }
  </div>
</div>
